import qs from 'qs';
import axios from 'axios';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const BASE_URL = 'https://api.giphy.com/v1/gifs';
const PAGE_SIZE = 15;
const RATING = 'pg-13';
const SAFE_RATING = 'pg';

function getGiphyKey() {
    const bootstrap = getBootstrap();
    return bootstrap.get('giphyKey');
}

/**
 * https://developers.giphy.com/docs/
 */
export default class GiphyApiClient {
    constructor() {
        this.key = getGiphyKey();
    }

    /**
     * https://developers.giphy.com/docs/#path--gifs-search
     * @param  {string} term
     * @param  {number} offset
     * @return {Promise}
     */
    search(term, offset) {
        const url = `${BASE_URL}/search`;
        const queryString = qs.stringify({
            q: term,
            limit: PAGE_SIZE,
            rating: RATING,
            api_key: this.key,
            offset,
        });

        return axios.get(`${url}?${queryString}`).then((response) => {
            if (!response.data.data) {
                return Promise.reject(new Error('Error with Giphy service.'));
            }
            return response.data.data;
        });
    }

    /**
     * https://developers.giphy.com/docs/#path--gifs-trending
     * @return {Promise}
     */
    trending(offset) {
        const url = `${BASE_URL}/trending`;
        const queryString = qs.stringify({
            limit: PAGE_SIZE,
            rating: SAFE_RATING,
            api_key: this.key,
            offset,
        });

        return axios.get(`${url}?${queryString}`).then((response) => {
            if (!response.data.data) {
                return Promise.reject(new Error('Error with Giphy service.'));
            }
            return response.data.data;
        });
    }
}
